import '@material/web/icon/icon.js'

import { css, html, LitElement, TemplateResult, nothing } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'
import { TOOL_POSITION } from '@operato/layout'
import { ContextController } from '@operato/shell'

@customElement('ox-context-page-toolbar')
export class ContextPageToolbar extends LitElement {
  static get styles() {
    return [
      css`
        :host {
          display: flex;
          flex-direction: row-reverse;
          gap: var(--spacing-medium);

          position: relative;

          justify-content: end;
          align-items: center;

          text-transform: capitalize;

          --context-action-bar-button-margin: var(--spacing-none);
          --context-action-bar-more-button-border-radius: 2px;

          --md-icon-size: 20px;
        }

        :host > div {
          display: flex;
          flex-direction: row;

          align-items: center;
          gap: var(--spacing-small);
        }

        md-icon {
          width: 32px;
          height: 32px;
          box-sizing: border-box;

          color: var(--md-sys-color-on-primary-container);
          background-color: var(--md-sys-color-primary-container);
          border: 1px solid var(--md-sys-color-primary-container);
          border-radius: var(--md-sys-shape-corner-small);
          padding: var(--spacing-small);

          &:hover {
            color: var(--md-sys-color-on-primary);
            background-color: var(--md-sys-color-primary);
            border-color: var(--md-sys-color-primary);
          }
        }

        @media screen and (max-width: 460px) {
          :host {
            gap: 0;
          }

          :host > div {
            gap: 0;
          }

          md-icon {
            border-radius: 0;
          }
        }
      `
    ]
  }

  private _context = new ContextController(this)

  @property({ type: Object }) context: any
  @property({ type: Array }) tools?: {
    position: TOOL_POSITION
    template: TemplateResult
    context?: string
  }[]

  render() {
    let contextKeys = Object.keys(this.context).filter(key => !!this.context[key])
    let tools = (this.tools || []).filter(tool => {
      if (!tool.context || contextKeys.includes(tool.context)) {
        return tool
      }
    })

    let frontEndTools = tools.filter(tool => tool.position == TOOL_POSITION.FRONT_END)
    let frontTools = tools.filter(tool => tool.position == TOOL_POSITION.FRONT)
    let centerTools = tools.filter(tool => tool.position == TOOL_POSITION.CENTER)
    let rearTools = tools.filter(tool => tool.position == TOOL_POSITION.REAR)
    let rearEndTools = tools.filter(tool => tool.position == TOOL_POSITION.REAR_END)

    return html`
      <slot name="front"></slot>
      ${frontEndTools.length > 0
        ? html`<div id="front-end">${frontEndTools.map(tool => html` ${tool.template} `)}</div>`
        : nothing}
      ${frontTools.length > 0
        ? html`<div id="front">${frontTools.map(tool => html` ${tool.template} `)}</div>`
        : nothing}
      ${centerTools.length > 0
        ? html`<div id="center">${centerTools.map(tool => html` ${tool.template} `)}</div>`
        : nothing}
      ${rearTools.length > 0 ? html`<div id="rear">${rearTools.map(tool => html` ${tool.template} `)}</div>` : nothing}
      ${rearEndTools.length > 0
        ? html`<div id="rear-end">${rearEndTools.map(tool => html` ${tool.template} `)}</div>`
        : nothing}
      <slot name="rear"></slot>
    `
  }

  protected willUpdate() {
    this.tools = this._context.tools
  }
}
